import { render, staticRenderFns } from "./FoldersSelect.vue?vue&type=template&id=51bbdcb3&scoped=true"
import script from "./FoldersSelect.vue?vue&type=script&lang=js"
export * from "./FoldersSelect.vue?vue&type=script&lang=js"
import style0 from "./FoldersSelect.vue?vue&type=style&index=0&id=51bbdcb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bbdcb3",
  null
  
)

export default component.exports